import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';

import { SwapiService } from './swapi.service'

import { AppComponent } from './app.component';
import { ListViewComponent } from './list-view/list-view.component';
import { DetialViewComponent } from './detial-view/detial-view.component';

@NgModule({
  declarations: [
    AppComponent,
    ListViewComponent,
    DetialViewComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
  ],
  providers: [SwapiService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts